// extracted by mini-css-extract-plugin
export var box = "_4j-2";
export var checkboxControl = "_4j-0";
export var checkboxRow = "_4j-9";
export var checked = "_4j-3";
export var descriptionSpacer = "_4j-b";
export var disabled = "_4j-4";
export var icon = "_4j-7";
export var input = "_4j-1";
export var labelSpacer = "_4j-a";
export var medium = "_4j-6";
export var small = "_4j-5";
export var text = "_4j-8";